import axios from "axios";

export const API_BASE = process.env.REACT_APP_BACKEND_URL || "";

export const api = axios.create({
  baseURL: `${API_BASE}/api`,
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});

// Attach Bearer token (from localStorage fallback) if available
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("callisto_token");
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// POST a multipart body. USE THIS FOR EVERY FormData REQUEST.
//
// The instance above sets `Content-Type: application/json` as a default, and
// axios 1.x reads that as an instruction to CONVERT: its default
// transformRequest does `hasJSONContentType ? JSON.stringify(formDataToJSON(
// data)) : data`. So a FormData body posted through `api.post` is silently
// turned into JSON, the file parts are lost, and the request arrives with no
// multipart fields at all — FastAPI then answers 422 "Field required" for the
// form field it never received.
//
// That is not hypothetical: it is what production returned on the first real
// filing attempt with receipts attached. Setting Content-Type to undefined
// lets the browser set `multipart/form-data` WITH the boundary, which is the
// one thing a hand-written header cannot supply.
export function postForm(url, formData, config = {}) {
  return api.post(url, formData, {
    ...config,
    headers: { ...(config.headers || {}), "Content-Type": undefined },
  });
}

// A receipt link is a relative API path (`/api/expenses/.../file`) because the
// bucket is PRIVATE and the backend serves the bytes. Turning it absolute is
// what lets an <a href> reach the API origin — and a top-level navigation
// carries the httpOnly `access_token` cookie (SameSite=None; Secure), which a
// Bearer header on an anchor could never do.
//
// Pass-through for anything already absolute, so a legacy row holding a full
// URL still opens rather than 404ing against the app's own origin.
export function fileUrl(path) {
  if (!path) return null;
  if (/^https?:\/\//i.test(path)) return path;
  return `${API_BASE}${path}`;
}

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const APP_VERSION = "v0.1.0";
